var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.33333C5.27081 4.33333 0.27819 12.3164 0.187891 12.4617C0.0663463 12.6148 0.000131406 12.8045 0 13C0.000153749 13.1677 0.048958 13.3318 0.140495 13.4723C0.141617 13.474 0.142746 13.4757 0.14388 13.4773C0.158781 13.5081 4.34965 21.6667 13 21.6667C21.6136 21.6667 25.7983 13.5882 25.8493 13.4892C25.8528 13.4836 25.8562 13.4779 25.8595 13.4723C25.951 13.3318 25.9998 13.1677 26 13C26 12.8053 25.9344 12.6163 25.8138 12.4634C25.8132 12.4628 25.8127 12.4623 25.8121 12.4617C25.7218 12.3164 20.7292 4.33333 13 4.33333ZM13 6.93333C16.3505 6.93333 19.0667 9.64947 19.0667 13C19.0667 16.3505 16.3505 19.0667 13 19.0667C9.64947 19.0667 6.93333 16.3505 6.93333 13C6.93333 9.64947 9.64947 6.93333 13 6.93333ZM13 10.4C12.3104 10.4 11.6491 10.6739 11.1615 11.1615C10.6739 11.6491 10.4 12.3104 10.4 13C10.4 13.6896 10.6739 14.3509 11.1615 14.8385C11.6491 15.3261 12.3104 15.6 13 15.6C13.6896 15.6 14.3509 15.3261 14.8385 14.8385C15.3261 14.3509 15.6 13.6896 15.6 13C15.6 12.3104 15.3261 11.6491 14.8385 11.1615C14.3509 10.6739 13.6896 10.4 13 10.4Z",
    fill: "current",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ee49f50b542d52a70e025e181d7b5639.svg";
export { ForwardRef as ReactComponent };